<template>
    <div class="header">
        <div>
            <a href="https://www.91jf.com/" target="_blank"><img :src="require('@/assets/images/login/logo.svg')" width="180px" height="64px" class="pointer" alt="91家纺网-叠石桥网销导航"></a>
            <span class="title">账户注册</span>
        </div>

        <div>
            <a-space align="center" :size="40">
            <!-- <a-button type="link" @click="toLogin" v-if="isShowLoginBtn">[ 账号登录 ]</a-button> -->
            <div class="bar_item pointer" v-for="(item,index) in topMenu" :key="index" @click="handleUrl(item)">
                <a-tooltip placement="top" :title="item.tip">
                  {{item.name}}
                  <img :src="item.img" width="16px" height="16px">
                </a-tooltip>
            </div>
            </a-space>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RegisterHeader',
    data () {
        return {
            topMenu: [
              // {
              //   name: '云仓直发',
              //   url: 'https://detail.91jf.com/cloudhouse/index',
              //   img: require('@/assets/images/login/yczf.svg'),
              //   target: '_blank'
              // },
              {
                name: '品牌加盟',
                url: 'https://www.91jf.com/default.php?act=corpbrand',
                img: require('@/assets/images/login/brand-franchising.svg'),
                target: '_blank'
              },
              {
                name: '保存到桌面',
                url: 'https://detail.91jf.com/desktop',
                img: require('@/assets/images/login/save-to-desk.svg'),
                // tip: '点击右键，选择“目标另存为...”，将此快捷方式保存到桌面即可',
                target: '_self'
              }
            ],
          logo:''
        }
    },
    created() {
      this.getLogo();
    },
    methods: {
        handleUrl ({ url, target }) {
            window.open(url, target)
        },
        toLogin () {
            this.$router.push('/login')
        },
        getLogo(){
          var _this = this;

          _this.$util.api('/logo',{},function(res){
            if(res.code == 10000 && res.data!=''){
              _this.logo = res.data
            }
          });
        }
    }
}
</script>

<style scoped>
.header {
    width: 832px;
    margin: 0px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 50px;
}

.header .bar_item {
    font-size: 14px;
    color: rgb(51, 51, 51);
}

.header .bar_item:hover {
    color: #fd5902;
}
.header .title {
    display: inline-block;
    font-size: 22px;
    color: #333;
    font-weight: 500;
    height: 64px;
    line-height: 64px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/login/RegisterHeader.vue